import EZO_I2C	from "../ezo_i2c.js";
import semver from "semver";
import sleep from "sleep";

class Module extends EZO_I2C {
  constructor(...args) {
    super(...args);

    this.id = "-";
    this.value = "-";
    this.status = "-";
    this.calibrationStatus = "-";
    
    /* publicate remote methods to clients */
    jfermi.RM_ezoph_clearCalibration = this.RM_ezoph_clearCalibration.bind(this);
    jfermi.RM_ezoph_calibrateTo4 = this.RM_ezoph_calibrateTo4.bind(this);
    jfermi.RM_ezoph_calibrateTo7 = this.RM_ezoph_calibrateTo7.bind(this);
    jfermi.RM_ezoph_calibrateTo10 = this.RM_ezoph_calibrateTo10.bind(this);
    
  }
  async initialize() {
    try {
      await this.open("/dev/i2c-1", 0x63);      
      this.id = await this.command("i");
      this.calibrationStatus = await this.command("Cal,?");
      this.slope = await this.command("Slope,?");
      this.firmwareVersion = await this.getFirmwareVersion();

      //TODO: lock to i2c
      //await this.command("Plock,1");
      //await sleep(1000);
      //console.log( await this.command("Plock,?") );
      

      this.usbProductName = "ezo_ph";
	  this.usbSerialNumber = "0x63";    
      this.name = "ezophSensor";
            
      this.status = "ok";
    } catch(e) {
      this.status = "failed";
      throw e;
    }
  }
  async update(devices) {
    var T;
    if (devices.temperatureSensor)
      T = devices.temperatureSensor.value;
    if (devices.ezortdSensor)
      T = devices.ezortdSensor.value;

    /* 
      from firmware version 2.12 we can use the RT command:
      RT,n set temperature compensation and take a reading
    */

    //var firmwareVersion = await this.getFirmwareVersion();    
    //firmwareVersion+=".0"; //semver does not like 2.12, he expects 2.12.0
    /*
      If the semver string a is greater than b, return 1. 
      If the semver string b is greater than a, return -1. If a equals b, return 0;
    */
    if (semver.compare(this.firmwareVersion, "2.12.0")>=0) {
      this.value = parseFloat( await this.command(`RT,${T?T:25}`) );   
    } else {
      await this.command(`T,${T?T:25}`);
      this.value = await this.command("R");      
    }             
    
    //repeated query for the following commands caused the pH measurement to return always the same value. measurement stucked
    //this.calibrationStatus = await this.command("Cal,?");
    //this.slope = await this.command("Slope,?");    
  } 
  async clearCalibration() {
    await this.command("Cal,clear");
    this.calibrationStatus = await this.command("Cal,?");
    this.slope = await this.command("Slope,?");          
  }
  async calibrateTo4() {
    await this.command("Cal,low,4.00");
    this.calibrationStatus = await this.command("Cal,?");
    this.slope = await this.command("Slope,?");              
  }
  async calibrateTo7() {
    await this.command("Cal,mid,7.00");
    this.calibrationStatus = await this.command("Cal,?");
    this.slope = await this.command("Slope,?");              
  }
  async calibrateTo10() {
    await this.command("Cal,high,10.00");
    this.calibrationStatus = await this.command("Cal,?");
    this.slope = await this.command("Slope,?");              
  }
  async RM_ezoph_clearCalibration(request) {
    try {
      await this.clearCalibration();
      console.log(`${request.client.username}: PH Sensor calibration data has successfully been deleted`);
    } catch(e) {
      console.error(`${request.client.username}: Clear calibration failed: ${e.message}`);
      throw e;
    }
    return true;
  }
  async RM_ezoph_calibrateTo4(request) {
    try {
      await this.calibrateTo4();
      console.log(`${request.client.username}: PH Sensor has successfully been calibrated to lowpoint (4.00)`);
    } catch(e) {
      console.error(`${request.client.username}: Calibration failed: ${e.message}`);
      throw e;
    }
    return true;    
  }
  async RM_ezoph_calibrateTo7(request) {
    try {
      await this.calibrateTo7();
      console.log(`${request.client.username}: PH Sensor has successfully been calibrated to midpoint (7.00)`);
    } catch(e) {
      console.error(`${request.client.username}: Calibration failed: ${e.message}`);
      throw e;
    }
    return true;
  }
  async RM_ezoph_calibrateTo10(request) {
    try {
      await this.calibrateTo10();
      console.log(`${request.client.username}: PH Sensor has successfully been calibrated to highpoint (10.00)`);
    } catch(e) {
      console.error(`${request.client.username}: Calibration failed: ${e.message}`);
      throw e;
    }
    return true;    
  }  
  toJSON() {
    return({
      id: this.id,
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,                  
      status: this.status,
      value: this.value,
      calibrationStatus: this.calibrationStatus,
      slope: this.slope      
    });
  }
}

export default Module;